// ** Styled Components
import { StyledTableHeaderCell, StyledTableRow } from "../styles";

// #####################################################

const TableHeader = ({ headers }) => {
	return (
		<StyledTableRow>
			{headers
				.filter((header) => !header.showInMain)
				.map((header) => {
					const key = `header - ${header.key} `;
					if (header.headerComponent) {
						return (
							<StyledTableHeaderCell
								{...header.headerCellProps}
								key={key}
							>
								{header.headerComponent(header, key)}
							</StyledTableHeaderCell>
						);
					}
					return (
						<StyledTableHeaderCell
							{...header.headerCellProps}
							key={key}
						>
							{header.headerName}
						</StyledTableHeaderCell>
					);
				})}
		</StyledTableRow>
	);
};

export default TableHeader;

// #####################################################
